import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { VehicleService } from "@core/services/vehicle.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-driveb-vehicle-status-dialog",
  templateUrl: "./vehicle-status-dialog.component.html",
  styleUrls: ["./vehicle-status-dialog.component.scss"],
  standalone: false
})
export class VehicleStatusDialogComponent implements OnInit {
  statusForm: UntypedFormGroup;
  currentStatus: boolean = null;

  statusOptions = [
    { value: true, label: "vehicle-status.active" },
    { value: false, label: "vehicle-status.inactive" }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private vehicleService: VehicleService,
    private matDialogRef: MatDialogRef<VehicleStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { vehicleId: number; currentActive?: boolean }
  ) {
    this.statusForm = this.formBuilder.group({
      active: [this.currentStatus, Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadCurrentStatus();
  }

  private loadCurrentStatus(): void {
    if (!this.data?.vehicleId) {
      this.currentStatus = this.data?.currentActive ?? null;
      this.statusForm.patchValue({ active: this.currentStatus });
      return;
    }

    this.vehicleService
      .findById(this.data.vehicleId)
      .pipe(first())
      .subscribe(
        (vehicle) => {
          this.currentStatus = vehicle.active;
          this.statusForm.patchValue({ active: this.currentStatus });
        },
        () => {
          this.currentStatus = this.data?.currentActive ?? null;
          this.statusForm.patchValue({ active: this.currentStatus });
        }
      );
  }

  closeDialog(isSubmitted: boolean): void {
    if (isSubmitted && this.statusForm.valid) {
      this.matDialogRef.close({
        active: this.statusForm.get("active")?.value
      });
    } else {
      this.matDialogRef.close(null);
    }
  }
}
